import React from 'react';

interface FileChooserProps {
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileChooser: React.FC<FileChooserProps> = ({ onFileChange }) => {
  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const event = {
        ...e,
        target: { files: e.dataTransfer.files }
      } as unknown as React.ChangeEvent<HTMLInputElement>;
      onFileChange(event);
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <div
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      style={{
        border: dragActive ? '2.5px solid #2a2a4a' : '2px dashed #b0b6c3',
        background: dragActive ? '#e0e0f8' : '#f9f9f9',
        borderRadius: 10,
        padding: 32,
        marginBottom: 28,
        maxWidth: 500,
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        boxShadow: '0 1px 8px rgba(0,0,0,0.04)',
        cursor: 'pointer',
        transition: 'background 0.2s, border 0.2s',
        position: 'relative',
      }}
      onClick={handleClick}
    >
      <input
        ref={inputRef}
        type="file"
        accept=".csv,.xlsx"
        onChange={onFileChange}
        style={{ display: 'none' }}
      />
      <div style={{ fontSize: 18, color: '#2a2a4a', fontWeight: 600, marginBottom: 8 }}>
        Drag & Drop your CSV or Excel (XLSX) file here
      </div>
      <div style={{ fontSize: 15, color: '#444', marginBottom: 10 }}>
        or <span style={{ color: '#2a2a4a', textDecoration: 'underline', cursor: 'pointer' }}>browse</span> to select a file
      </div>
      <div style={{ fontSize: 13, color: '#888', marginTop: 8 }}>
        Only .csv and .xlsx files are supported<br />
        <span style={{ color: '#666' }}>
          <b>Note:</b> Rows are expected to be <b>genes</b> and columns are <b>sample groups</b>.
        </span>
      </div>
    </div>
  );
};

export default FileChooser;
